/* models/widgets/tables/main */ function _(require, module, exports) {
    var Tables = require(482) /* ./index */;
    exports.Tables = Tables;
    var base_1 = require(0) /* ../../../base */;
    base_1.register_models(Tables);
}
